import {Component, OnInit} from '@angular/core';
import {BetweenDates} from '../models/eventRequest';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import * as moment from 'moment';
import {PaymentService} from '../_services/payment.service';
import {StudentService} from '../_services/student.service';
import {DateService} from '../_services/date.service';

declare let $: any;

@Component({
  selector: 'app-board-admin',
  template: `
    <div class="admin-page">
      <div class="container admin-shell">
        <app-note></app-note>

        <section class="admin-period-banner">
          <div class="admin-period-banner-icon">
            <i class="fa fa-calendar"></i>
          </div>

          <div class="admin-period-banner-copy">
            <span class="admin-period-label">Période sélectionnée</span>
            <strong>{{ periode }}</strong>
          </div>

          <div class="admin-period-actions">
            <div class="btn-group">
              <button type="button" class="btn btn-outline-secondary admin-period-dropdown" (click)="openCalendarForm()">
                <i class="fa fa-calendar"></i> Calendrier
              </button>
              <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Période</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" (click)="onChangePeriode('today')">Aujourd'hui</a>
                <a class="dropdown-item" (click)="onChangePeriode('week')">Cette semaine</a>
                <a class="dropdown-item" (click)="onChangePeriode('lastWeek')">Semaine dernière</a>
                <a class="dropdown-item" (click)="onChangePeriode('month')">Ce mois-ci</a>
              </div>
            </div>

            <button type="button" class="btn btn-primary admin-period-primary" (click)="openCalendarForm()">
              <i class="fa fa-search"></i> Voir la période
            </button>
          </div>
        </section>

        <div *ngIf="messageError" class="alert alert-danger admin-alert" role="alert">
          {{ messageError }}
        </div>

        <section class="admin-kpis">
          <article class="admin-card admin-kpi-card admin-kpi-card--blue"
                   [ngClass]="{ 'admin-kpi-card--active': showRegistrations }"
                   role="button"
                   tabindex="0"
                   [attr.aria-pressed]="showRegistrations"
                   (click)="selectPanel('registrations')"
                   (keydown.enter)="selectPanel('registrations')"
                   (keydown.space)="selectPanel('registrations')">
            <div class="admin-kpi-head">
              <span class="admin-kpi-icon" aria-hidden="true"><i class="fa fa-users"></i></span>
              <span class="admin-kpi-label">Inscriptions</span>
            </div>

            <div class="admin-kpi-body">
              <strong class="admin-kpi-value">{{ totalRegistrations || 0 }}</strong>
              <span class="admin-kpi-unit">Inscription{{ (totalRegistrations || 0) > 1 ? 's' : '' }}</span>
            </div>
            <span class="admin-kpi-state">{{ showRegistrations ? 'Liste affichée' : 'Cliquer pour afficher' }}</span>
          </article>

          <article class="admin-card admin-kpi-card admin-kpi-card--green"
                   [ngClass]="{ 'admin-kpi-card--active': showPayments }"
                   role="button"
                   tabindex="0"
                   [attr.aria-pressed]="showPayments"
                   (click)="selectPanel('payments')"
                   (keydown.enter)="selectPanel('payments')"
                   (keydown.space)="selectPanel('payments')">
            <div class="admin-kpi-head">
              <span class="admin-kpi-icon" aria-hidden="true"><i class="fa fa-database"></i></span>
              <span class="admin-kpi-label">Paiements</span>
            </div>

            <div class="admin-kpi-body">
              <strong class="admin-kpi-value">{{ totalPayments || 0 }} €</strong>
            </div>
            <span class="admin-kpi-state">{{ showPayments ? 'Liste affichée' : 'Cliquer pour afficher' }}</span>
          </article>
        </section>

        <section class="admin-card admin-list-panel" *ngIf="showRegistrations">
          <app-student-list
            [iPageStudent]="studentPage"
            [iStudents]="studentPage?.content"
            [iUseExternalDataFlow]="true"
            (iSearchTermChanged)="onStudentsSearch($event)"
            (iPageNumber)="onChangeStudentsPage($event)">
          </app-student-list>
        </section>

        <section class="admin-card admin-list-panel" *ngIf="showPayments">
          <app-payment-list
            [iShowStudent]="true"
            [iShowPayments]="showPayments"
            [iPayments]="paymentPage?.content"
            [iPagePayment]="paymentPage"
            [iShowUpdateBtn]="false"
            [iTotalPaymentDetails]="totalPaymentDetails"
            (iPageNumber)="onChangePaymentPage($event)">
          </app-payment-list>
        </section>
      </div>
    </div>

    <div class="modal fade" id="calendarModal" tabindex="-1" role="dialog" aria-labelledby="calendarLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content admin-modal">
          <div class="modal-header">
            <h3 class="modal-title" id="calendarLabel">
              Choisir la periode
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form [formGroup]="calendarForm" #f="ngForm" name="newEventForm" (ngSubmit)="isSubmited(); f.form.valid && onSubmitCalendarForm()" novalidate>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <label for="startDate" class="col-form-label">Debut</label>
                  <input id="startDate" type="date" class="form-control"
                         name="startDate" formControlName="startDate" required>
                </div>
                <div class="col-md-6 form-group">
                  <label for="endDate" class="col-form-label">Fin</label>
                  <input id="endDate" type="date" class="form-control"
                         name="endDate" formControlName="endDate" required>
                </div>
              </div>

              <p class="alert alert-danger" role="alert" *ngIf="submited && f.form.value.startDate == null">
                Merci de definir la date de debut.
              </p>
              <p class="alert alert-danger mb-0" role="alert" *ngIf="submited && f.form.value.endDate == null">
                Merci de definir la date de fin.
              </p>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
              <button type="submit" class="btn btn-primary">Valider</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./board-admin.component.css']
})
export class BoardAdminComponent implements OnInit {

  totalRegistrations: any;
  studentPage: any;
  studentPageSize = 10;
  studentSearchTerm = '';
  totalPayments: any;
  totalPaymentDetails: any;
  paymentPage: any;
  activePanel: 'registrations' | 'payments' = 'registrations';
  messageError = '';
  betweenDates: BetweenDates = this.dateService.getCurrentWeekBoundaries();
  startDate: Date = this.dateService.getStartWeek();
  endDate: Date = this.dateService.getEndWeek();
  periodeName = 'Cette semaine';
  periode = '';
  calendarForm = this.fb.group({
    startDate: [null, Validators.required],
    endDate: [null, Validators.required],
  });
  showCalendarForm = false;
  submited = false;

  constructor(private fb: UntypedFormBuilder, private studentService: StudentService, private paymentService: PaymentService,
              private dateService: DateService) {
    this.updatePeriode(this.betweenDates);
    this.loadAllDataPage(this.betweenDates, 0);
  }


  ngOnInit(): void {
    this.updatePeriode(this.dateService.getCurrentWeekBoundaries());
  }

  updatePeriode(betweenDates: BetweenDates): void {
    this.periode = `DU ${moment(betweenDates.startAt).format('DD/MM/YYYY')} AU ${moment(betweenDates.endAt).format('DD/MM/YYYY')}`;
  }

  get showRegistrations(): boolean {
    return this.activePanel === 'registrations';
  }

  get showPayments(): boolean {
    return this.activePanel === 'payments';
  }

  selectPanel(panel: 'registrations' | 'payments'): void {
    this.activePanel = panel;
  }

  onChangeStudentsPage($event: number): void {
    this.getStudentsPage(this.betweenDates, $event);
  }

  onStudentsSearch(searchTerm: string): void {
    this.studentSearchTerm = searchTerm.trim();
    this.getStudentsPage(this.betweenDates, 0);
  }

  onChangePaymentPage($event: number): void {
    this.getPaymentsPage(this.betweenDates, $event);
  }

  onChangePeriode(periode: string): void {
    switch (periode) {
      case 'today':
        this.periodeName = 'Aujourd\'hui';
        this.betweenDates = this.dateService.getDayBoundaries();
        break;
      case 'week':
        this.periodeName = 'Cette Semaine';
        this.betweenDates = this.dateService.getCurrentWeekBoundaries();
        break;
      case 'lastWeek':
        this.periodeName = 'La Semaine Dernière';
        this.betweenDates = this.dateService.getLastWeekBoundaries();
        break;
      case 'month':
        this.periodeName = 'Ce Mois ci';
        this.betweenDates = this.dateService.getCurrentMonthBoundaries();
        break;
      default:
        console.error('Unknown period:', periode);
        return;
    }
    this.updatePeriode(this.betweenDates);
    this.loadAllDataPage(this.betweenDates, 0);
  }


  private loadAllDataPage(betweenDates: BetweenDates, page: number): void {
    this.getStudentsPage(betweenDates, page);
    this.getPaymentsPage(betweenDates, page);
    this.getTotalPayments(betweenDates);
  }

  private getTotalPayments(dates: BetweenDates): void {
    this.paymentService.getTotalPaymentsBetweenDates(dates).subscribe(
      data => {
        this.totalPayments = data;
      }, error => {
        this.messageError = error;
      }
    );
    this.paymentService.getTotalGroupByPaymentsBetweenDates(dates).subscribe(
      data => {
        this.totalPaymentDetails = data;
      }, error => {
        this.messageError = error;
      }
    );
  }

  private getStudentsPage(dates: BetweenDates, page: number): void {
    if (this.studentSearchTerm) {
      this.getFilteredStudentsPage(dates, page);
      return;
    }

    this.studentService.getStudentsBetweenDates(dates, page, this.studentPageSize).subscribe(
      data => {
        this.studentPage = data;
        this.totalRegistrations = data.totalElements;
      },
      err => {
        this.messageError = err;
      }
    );
  }

  private getFilteredStudentsPage(dates: BetweenDates, page: number): void {
    const totalStudents = Number(this.totalRegistrations || this.studentPage?.totalElements || this.studentPageSize);
    const fetchSize = Math.max(totalStudents, this.studentPageSize, 250);
    const normalizedSearch = this.studentSearchTerm.toLocaleLowerCase();

    this.studentService.getStudentsBetweenDates(dates, 0, fetchSize).subscribe(
      data => {
        const filteredStudents = (data.content || []).filter((student: any) => this.matchesStudentSearch(student, normalizedSearch));
        const startIndex = page * this.studentPageSize;
        const endIndex = startIndex + this.studentPageSize;
        const totalPages = filteredStudents.length === 0 ? 0 : Math.ceil(filteredStudents.length / this.studentPageSize);

        this.studentPage = {
          ...data,
          content: filteredStudents.slice(startIndex, endIndex),
          empty: filteredStudents.length === 0,
          first: page === 0,
          last: totalPages === 0 || page >= totalPages - 1,
          number: totalPages === 0 ? 0 : page,
          totalPages,
          totalElements: filteredStudents.length
        };
        this.totalRegistrations = data.totalElements;
      },
      err => {
        this.messageError = err;
      }
    );
  }

  private matchesStudentSearch(student: any, normalizedSearch: string): boolean {
    const searchableValue = [
      student?.lastname,
      student?.firstname,
      student?.formula?.name,
      student?.registrationDate
    ]
      .filter(Boolean)
      .join(' ')
      .toLocaleLowerCase();

    return searchableValue.includes(normalizedSearch);
  }

  private getPaymentsPage(dates: BetweenDates, page: number): void {
    this.paymentService.getPaymentsBetweenDates(dates, page, 10).subscribe(
      data => {
        this.paymentPage = data;
      },
      err => {
        this.messageError = err;
      }
    );
  }

  openCalendarForm(): void {
    this.showCalendarForm = true;
    $('#calendarModal').modal('show');
  }

  onSubmitCalendarForm(): boolean {
    $('#calendarModal').modal('hide');
    this.betweenDates = new BetweenDates(this.calendarForm.value.startDate, this.calendarForm.value.endDate);
    this.getPaymentsPage(this.betweenDates, 0);
    this.getTotalPayments(this.betweenDates);
    this.getStudentsPage(this.betweenDates, 0);
    this.updatePeriode(this.betweenDates);
    return true;
  }

  isSubmited(): void {
    this.submited = true;
  }

}
